import AppSignedIn from './signedin.tsx'
import logo from './assets/AmpersandLogoYellow.svg'
import { ClerkProvider, SignedIn, SignedOut, SignIn } from "@clerk/clerk-react";

const clerkPubKey = import.meta.env.VITE_APP_CLERK_PUB_KEY;

// Clerk derives its shades from these, so they must be literal colors rather
// than CSS variables. Keep them in sync with the brand colors in index.css.
const clerkAppearance = {
  variables: {
    colorPrimary: '#2B2B2B', // --color-brand-charcoal
    colorBackground: '#FDFBF9', // --color-brand-cream-100
    colorText: '#2B2B2B', // --color-brand-charcoal
    colorTextSecondary: '#7D7870', // cream-700
    colorInputBackground: '#FFF',
    colorInputText: '#2B2B2B', // --color-brand-charcoal
    fontFamily: "'Helvetica Neue', sans-serif",
    borderRadius: '0',
  },
  // Clerk v4 gives the card a fixed width and side margins, so cap it to the
  // screen to keep it visible on phones.
  elements: {
    rootBox: { maxWidth: '100%' },
    card: {
      borderRadius: 'var(--radius-sm)',
      maxWidth: '100%',
      margin: 0,
      boxSizing: 'border-box',
    },
  },
};

function App() {
  if (clerkPubKey === undefined) {
    console.error("Clerk public key not set");
    return <div>CLERK KEY NOT SET!</div>;
  }

  return (
    <ClerkProvider publishableKey={clerkPubKey}>
      <header className="header">
        <img className="logo" src={logo} alt="Ampersand" />
      </header>
      <main className="main">
        <SignedIn>
            <AppSignedIn />
        </SignedIn>
        <SignedOut>
            {/* Adding a redirectUrl prevents occasional redirection to console.withampersand.com */}
            <SignIn redirectUrl={window.location.href} appearance={clerkAppearance} />
        </SignedOut>
      </main>
    </ClerkProvider>
  )
}

export default App
